module.exports = __webpack_public_path__ + "img/2a547eb7cd4682abcb793549b52f97d.434acfee.png";